var _ = require('lodash');

(function Module() {
	'use strict';

	mySynch.directive('popuptable', [
		'$document',
		function popuptable($document) {
			return {
				restrict : "E",
				scope: {
					question: '=',
					manageActionItems: '&',
					toggleIncludeInudstryRecommends: '&'
				},
				link: function(scope) {
					scope.isPopupVisible = false;
					
					var $selectPopup = $(".select-popup");
					$document.bind('click', function(event){
						var location = $selectPopup.has(event.target).length;
						if (location <= 0) {
							scope.isPopupVisible = false;
						}
						if (!scope.$$phase) {
							scope.$digest();
						}
					});

					var $popup = $(".popup");

					function closeAllPopup() {
						$document.bind('click', function(event){
							var location = $popup.has(event.target).length;
							if (location <= 0) {
								scope.isPopupVisible = false;
							}
							if (!scope.$$phase) {
								scope.$digest();
							}
						});
					}
					
					scope.toggleSelect = function(){
						var popupVisible = _.clone(scope.isPopupVisible);
						closeAllPopup();
						
						if (!popupVisible) {
							setTimeout(function(){
								scope.isPopupVisible = !scope.isPopupVisible;
								if (!scope.$$phase) {
									scope.$digest();
								}
							}, 100);
						}
					};
					
					scope.closePopup = function(){
						scope.isPopupVisible = !scope.isPopupVisible;
					};

				   scope.toggleActionItem = function(question){
					   scope.manageActionItems(question);
				   };
				   
				   scope.onToggleIncludeInudstryRecommends = function(question){
					   scope.toggleIncludeInudstryRecommends(question);
				   };
				},
				template: 	'<div class="select-popup mt--1">' +
								'<a class="btn-option  hidden-xs" ng-click="toggleSelect()">' +
									'<span class="option-size">' +
										'...' +
									'</span>' +
								'</a>' +
								'<a class="link-color visible-xs" ng-click="toggleSelect()">' +
							    	'<span>' + 
								       'Add Action Item' +
									'</span>' +
								'</a>' +
								'<div class="popup flex-row flex-justify-left" ng-show="isPopupVisible">' +
									'<div class="no-padding col-xs-12 col-sm-12 col-md-12">' + 
										'<div class="flex-row flex-justify-left">' +
											'<div class="no-padding col-xs-12 col-sm-12 col-md-12">' + 
												'<div class="flex-row flex-justify-left">' +
													'<div class="no-padding col-xs-10 col-sm-10 col-md-10">' + 
														'<div>Management Plan</div>' +
													'</div>' +
													'<div class="col-xs-2 col-sm-2 col-md-2">' + 
														'<div class="select-popup-close-div" ng-click="closePopup()">x</div>' +
													'</div>' +
												'</div>' +
												'<div class="flex-row flex-justify-left mt-2">' +
													'<div class="row row-check mt-2">' +
														'<div class="pull-left mr-check">' +
															'<label class="switch">' +
																'<input  type="checkbox" id="question-action-item-toggle-{{question.QuestionId}}" ng-model="question.Answer.ActionItem" ng-click="toggleActionItem(question)" checked>' +
																'<span class="slider-check round"></span>' +
															'</label>' +
														'</div>' +
														'<div class="pull-left pl-2">' +
															'<span>Add as Action Item</span>' +
														'</div>' +
													'</div>' +
												'</div>' +
											'</div>' +
										'</div>' +
										'<div class="flex-row flex-justify-left">' +
											'<div ng-if="question.QuestionDetailsJson.industryRecommends.rtf !== null">' +
												'<div class="row row-check mt-2">' +     
													'<div class="pull-left mr-check">' +
														'<label class="switch">' +
															'<input type="checkbox" id="question-industry-recommends-toggle-{{question.QuestionId}}" ng-model="question.Answer.IncludeIndustryRecommends" ng-click="onToggleIncludeInudstryRecommends(question)" ng-class="{\'mysynch-disabled\': question.Answer.ActionItem != true}" ng-disabled="question.Answer.ActionItem != true">' +
															'<span class="slider-check round"></span>' +
														'</label>' +
													'</div>' +
													'<div class="pull-left pl-2"> <span> Include Industry Recommendation </span></div>' +
												'</div>' + 
												'<div class="row row-check mt-2">' + 
													'<div class="pull-left content-check" ng-class="{\'mysynch-disabled\': question.Answer.ActionItem != true}">' +
														'<div class="mt-2 content-child popuptable-question-industry-recommends-reference">' +
															'{{question.QuestionDetailsJson.industryRecommends.rtf == undefined || question.QuestionDetailsJson.industryRecommends.rtf == "---" ? "N/A" : question.QuestionDetailsJson.industryRecommends.rtf}}' +
														'</div>' +
														'<div class="mt-2 content-child" ng-if="question.QuestionDetailsJson.industryRecommends.refCitations.reference !== null">' +
															'<span> {{question.QuestionDetailsJson.industryRecommends.refCitations.reference}}</span>' +
															'<a ng-if="question.QuestionDetailsJson.industryRecommends.refCitations.url !== null" href="{{question.QuestionDetailsJson.industryRecommends.refCitations.url}}" target="_blank" class="btn-link link-color"><span class="link-text">View Reference</span>&nbsp;&nbsp;<i class="fa fa-external-link"></i></a>' +
														'</div>' +
													'</div>' +
												'</div>' + 
											'</div>' +
										'</div>' +
									'</div>' + 
								'</div>' +
			  				'</div>',
  				replace: true,
			};
		}
	]);
})();
